<div class="rv-card" [class.open]="open">
  <span
    class="rv-card-header rv-grid-small rv-flex"
    [class.rv-pointer]="!disabled"
    [class.no-bottom]="!open"
    (click)="toggle()"
  >
    <ng-content select="[heading]"></ng-content>
    <riv-icon
      *ngIf="open"
      [class.rv-invisible]="disabled"
      [name]="'ChevronUp'"
    ></riv-icon>
    <riv-icon
      *ngIf="!open"
      [class.rv-invisible]="disabled"
      [name]="'ChevronDown'"
    ></riv-icon>
  </span>
  <span *ngIf="open">
    <ng-content></ng-content>
  </span>
  <span class="rv-card-footer" *ngIf="footerCard && open">
    <ng-content select="[footer]"></ng-content>
  </span>
</div>
